import styled from 'styled-components';

export default styled.button.attrs((props) => ({
  type: props.type ? props.type : 'button',
}))`
  width: 100%;
  border-radius: 8px;
  background: ${(props) => (!!props.primaryColor ? props.primaryColor : props.black ? '#002a64' : '#023a86')};
  color: #fff;
  margin-bottom: 20px;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: 0 !important;
  transition: all.3s;
  cursor: pointer;

  svg {
    font-size: 25px;
    margin-left: 10px;
    margin-top: 2px;
  }

  &:hover {
    opacity: 0.9;
  }

  &:active {
    transform: scale(0.99);
  }
`;
